import { useEffect, useState } from "react"
import { motion, useAnimationControls } from "framer-motion"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import { headline30, bold, body50 } from "css/text"
import getMediaQuery from "css/breakpoints"

import { useValue } from "./context"

export const TermMarker = styled.span`
  ${body50}
  ${bold}
  padding-inline-end: 2rem;
`

export const TermLabel = styled.span`
  ${headline30}
  margin-inline-end: 20px;
`

export const Term = styled(motion.dt)`
  display: inline-flex;
  width: 100%;
  padding-block: 20px;

  &:first-of-type {
    padding-block-start: 0;
  }
`

export const Desc = styled(motion.dd)`
  position: relative;
  border-bottom: solid 1px rgb(var(--light-black) / 0.3);
  overflow: hidden;
`

export const DescContent = styled(motion.div)`
  ${body50}
  &::after {
    content: "";
    display: block;
    padding-block-end: 20px;
  }

  &::before {
    content: "";
    display: block;
    padding-block-end: 20px;
  }

  ${getMediaQuery("m")} {
    &::before {
      content: "";
      display: block;
      padding-block-end: 0;
    }
  }
`

export const TermButton = styled.button`
  border: none;
  padding: 0;
  background: transparent;
  width: 100%;
  text-align: start;
  color: inherit;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: min-content auto;

  align-items: start;

  &:hover {
    cursor: pointer;
  }
`

export default function DescItem({ index, term_marker, term, description, meta }) {
  const console = useConsole()

  const { currentIndex } = useValue()
  const anim = useAnimationControls()

  const [isCurrent, setIsCurrent] = useState(currentIndex.get() === index)

  const termVariants = {
    open: { color: "rgb(var(--light-black))" },
    close: { color: "rgb(118 118 118)" },
  }
  const descVariants = {
    open: { height: "auto", opacity: 1 },
    close: { height: "0", opacity: 0 },
  }

  const onClick = e => currentIndex.set(index)

  const onIndexChange = i => {
    setIsCurrent(i === index)
    anim.start(i === index ? "open" : "close")
  }
  useEffect(() => currentIndex.onChange(onIndexChange))

  return (
    <>
      <Term variants={termVariants} initial={currentIndex.get() === index ? "open" : "close"} animate={anim} transition={{ type: "tween", duration: 0.4 }}>
        <TermButton type='button' id={meta.uid} onClick={onClick} aria-expanded={isCurrent} aria-controls={`content-${meta.uid}`}>
          <TermMarker dangerouslySetInnerHTML={{ __html: term_marker }} />
          <TermLabel dangerouslySetInnerHTML={{ __html: term }} />
        </TermButton>
      </Term>
      <Desc id={`content-${meta.uid}`} aria-labelledby={meta.uid}>
        <DescContent
          variants={descVariants}
          initial={currentIndex.get() === index ? "open" : "close"}
          animate={anim}
          transition={{ type: "tween", duration: 0.3 }}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </Desc>
    </>
  )
}
